module.exports = __webpack_public_path__ + "static/media/CGarchitect.99e24ad1.jpg";